<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="icons/chevron/right" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="icons/chevron/down"
        transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) translate(0.000000, 0.000000)"
      >
        <polygon id="bg" points="0 0 16 0 16 16 0 16" />
        <polygon
          id="chevron"
          :fill="color"
          fill-rule="evenodd"
          points="8 10.1713834 14.5859417 3.58634474 16.0000583 5.00065526 8 12.9996166 -5.82977429e-05 5.00065526 1.4140583 3.58634474"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D1D'
    }
  }
};
</script>
